import axios from "@axios";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getCustomerSalesReportsProduct", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchUsersExcel(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getCustomerSalesReportsProductExcel", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/getOneOffice/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchOrderService(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getCustomerSalesReportsService", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchOrderServiceExcel(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getCustomerSalesReportsServiceExcel", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchOrderCustomer(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getCustomerSalesReportsCustomer", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchOrderCustomerExcel(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getCustomerSalesReportsCustomerExcel", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchPaymamentEmployees(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getPaymamentEmployes", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchPaymamentEmployeesExcel(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/getPaymamentEmployesExcel", { params: queryParams })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
